import { getDecodedConsulData } from '@shared/lib/consul'
import { NewServiceType } from '../model/tsp.types'

export const fetchNewServices = async () => {
  try {
    const data = await getDecodedConsulData<{ newServices: NewServiceType[] }>('/services/new-services/value')

    return data.newServices || []
  } catch (error) {
    console.error('fetchNewServices:', error)

    return []
  }
}
